import assignLocationValues from '../helpers/assign-location-values'
import MapsService from '@/api/maps-service'

export default {
  data() {
    return {
      geocodeFinished: false,
      geocodeSucceeded: null
    }
  },

  computed: {
    commonLocationOptions() {
      let options = {}

      if (this.boundaryBox && this.boundaryBox.min_latitude && this.boundaryBox.max_latitude) {
        options.bounds = {south: this.boundaryBox.min_latitude,
                          west: this.boundaryBox.min_longitude,
                          north: this.boundaryBox.max_latitude,
                          east: this.boundaryBox.max_longitude}
      }

      return options
    },

    geocoderOptions() {
      let options = this.commonLocationOptions

      // the geocoder only supports a single country
      if (this.country !== null && this.country !== '' && !Array.isArray(this.country)) {
        options.country = this.country
      }

      return options
    },

    autocompleteOptions() {
      let options = this.commonLocationOptions

      // the autocomplete component supports an array of countries
      if (this.country !== null && this.country !== '') {
        options.countries = Array.isArray(this.country) ? this.country : [this.country]
      }

      return options
    },

    showValidationError() {
      return this.geocodeFinished && !this.geocodeSucceeded
    }
  },

  methods: {
    geocodeLocation(postGeocode) {
      // start with the options we always pass to the geocoder
      const geocoderRequest = Object.assign({}, this.geocoderOptions)

      // set the address to be whatever the user typed in the field.
      geocoderRequest['address'] = this.currentQuery

      MapsService.geocode(geocoderRequest).then((results) => {
        if (results.length > 0) {
          this.geocodeSucceeded = true
          this.location = assignLocationValues(this.location, results[0], {keepExistingFieldValues: false, excludeVenue: this.excludeVenueField})

          // If we're using the venue field, use user's query as venue if it's not returned by Google Maps API
          if (!this.excludeVenueField && (!this.location.venue || this.location.venue === '')) {
            this.location.venue = this.currentQuery
          } else {
            this.currentQuery = this.location.query
          }
        } else {
          this.geocodeSucceeded = false
        }

        this.geocodeFinished = true

        postGeocode()
      })
    },

    autocompletePlaceChanged(place) {
      if ('coordinates' in place) {
        this.location = assignLocationValues({}, place, {keepExistingFieldValues: false, excludeVenue: this.excludeVenueField})
        this.changeAttribute()                // Components including the mixin must implement this method
      }
    }
  }
}
